/**
 * useApiCallLog — subscribe to the global API call ring buffer.
 */
import { useEffect, useState } from 'react';
import {
  getApiCallLogSnapshot,
  subscribeApiCallLog,
  type ApiCallLogEntry,
} from '../services/apiCallLogStore';

export function useApiCallLog(): ReadonlyArray<ApiCallLogEntry> {
  const [entries, setEntries] = useState<ReadonlyArray<ApiCallLogEntry>>(() => getApiCallLogSnapshot());
  useEffect(() => {
    const unsub = subscribeApiCallLog((next) => setEntries(next));
    return unsub;
  }, []);
  return entries;
}
